import { render, staticRenderFns } from "./cellInfo.vue?vue&type=template&id=1bd86e0c&scoped=true&"
import script from "./cellInfo.vue?vue&type=script&lang=js&"
export * from "./cellInfo.vue?vue&type=script&lang=js&"
import style0 from "./cellInfo.vue?vue&type=style&index=0&id=1bd86e0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd86e0c",
  null
  
)

export default component.exports